/**
 * @name WorkAnniversariesDialog
 * @description Modal de próximos aniversarios laborales
 * @author Ricardo Guerra
 */

import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';

import { DataGrid } from '@components';
import { Icons, MUI } from '@styles';

const WorkAnniversariesDialog = (props) => {
  const {
    anniversaries,
    open,
    onClose
  } = props;

  const monthNames = ['jan', 'feb', 'mar', 'apr', 'may', 'jun',
    'jul', 'aug', 'sep', 'oct', 'nov', 'dec'
  ];

  const columns = [
    { type: 'complex', id: ['Foto', 'Nombres', 'Area'], label: i18n.t('GenericMessages.employee'), visible: true, filter: null },
    { id: 'Sucursal', label: i18n.t('GenericMessages.branch'), visible: true, filter: null, sort: true },
    { id: 'FechaAniversario', label: i18n.t('GenericMessages.date'), visible: true, filter: 'BirthdayDateFilter', sort: true },
    { id: 'Antiguedad', label: `${i18n.t('GenericMessages.seniority')} (${i18n.t('GenericMessages.years').toLowerCase()})`, visible: true, filter: null, align: 'right' }
  ];

  const month = new Date().getMonth();
  // const today = moment().format('DD/MM');

  /* anniversaries.forEach((item) => {
    if (moment(item.FechaAniversario).format('DD/MM') >= today) {
      item.Antiguedad += 1;
    }
  });*/

  return (
    <MUI.Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
    >
      <MUI.DialogTitle>
        {`${i18n.t('Home.anniversariesMonth')} ${i18n.t(`Months.${[monthNames[month]]}`)}`}
        <MUI.DialogBoxClose onClick={onClose}>
          <Icons.Close />
        </MUI.DialogBoxClose>
      </MUI.DialogTitle>
      <MUI.DialogContent>
        <MUI.Box padding="16px">
          <DataGrid
            canSort={true}
            columns={columns}
            rows={anniversaries}
          />
        </MUI.Box>
      </MUI.DialogContent>
      <MUI.DialogActions>
        <MUI.ButtonText onClick={onClose}>
          {i18n.t('DialogConfirm.close')}
        </MUI.ButtonText>
      </MUI.DialogActions>
    </MUI.Dialog>
  );
};

WorkAnniversariesDialog.propTypes = {
  // Array con la información de los aniversarios laborales del mes.
  anniversaries: PropTypes.array.isRequired,
  // Boolean que indica si el modal esta abierto.
  open: PropTypes.bool.isRequired,
  // Función que se ejecuta para cerrar el modal.
  onClose: PropTypes.func.isRequired
};

export default WorkAnniversariesDialog;